/**
 * Store reference for use in non-React code (e.g. fetch interceptors).
 * Set by App on mount.
 */
let storeRef = null;

export const setStore = store => {
  storeRef = store;
};

export const getStore = () => storeRef;
